<div class="grid-item-list-wrapper grid-item-list-wrapper-length-{{ items.length }}" #scrollAnchor>
  <ngx-masonry
    [options]="{
      gutter: 0,
      horizontalOrder: true
    }"
  >
    <div
      *ngFor="let media of displayedVideos; let index = index"
      ngxMasonryItem
      #videoGridItem
      class="video-grid-item masonry-item"
      (click)="itemClicked.emit({ media: media, index: index })"
    >
      <div class="card-wrapper" [style.paddingTop.%]="media.inverseRatio * 100">
        <div class="card-content">
          <div class="card-header h4">
            {{ media.title }}
          </div>
          <mb-media
            [media]="media"
            [class.media-image]="media.type === 'image'"
            [hoverplay]="true"
            [hideTitles]="true"
          ></mb-media>
          <div class="card-footer">
            <ul class="meta-items">
              <li class="meta-item">{{ media.extension }}</li>
              <li class="meta-item">{{ media.filesize | fileSize }}</li>
            </ul>
            <mb-action-container
              *ngIf="buttonItems.length"
              [buttonItems]="buttonItems"
              [resource]="media"
              (actionClick)="itemActionClicked.emit({ action: $event, media: media })"
            ></mb-action-container>
          </div>
        </div>
      </div>
    </div>
  </ngx-masonry>
</div>

<div *ngIf="showButtons" class="gallery-btn-wrapper">
  <div *ngIf="!allVideosVisible" (click)="onPagerButtonClick()" class="btn btn-secondary">
    {{ 'SHOW_MORE' | translate }}
  </div>
  <div *ngIf="!allVideosVisible; else hideAll" (click)="onToggleAllClick()" class="btn btn-secondary">
    {{ 'SHOW_ALL' | translate }}
  </div>
  <ng-template #hideAll>
    <div (click)="onToggleAllClick()" class="btn btn-secondary">
      {{ 'SHOW_LESS' | translate }}
    </div>
  </ng-template>
</div>
